import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { User } from '../../models/User';
import { AuthService, AuthState } from '../auth.service';

declare let toastr: any;

@Injectable({ providedIn: 'root' })
export class StorePermissionGuard {
  constructor(
    private userService: User,
    private auth: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const authState = this.auth.getAuthState();

    this.userService.establishSession();

    let permissions = route.data.storePermissions as Array<string>;
    let paramKey = route.data.paramKey as string;
    let msg =
      'You need access permission to use that part of the application. Please contact your account administrator.';

    switch (authState) {
      case AuthState.Anonymous:
        msg =
          'You need access permission to use that part of the application. <br><br>' +
          '<a class="btn btn-primary btn-block btn-schedule-a-demo no-content" href="https://www.pixalate.com/scheduledemo" target="_blank">Schedule a Demo!</a>';

      case AuthState.Authenticated:
        if (!permissions?.length) return true;
        if (
          route.paramMap.get(paramKey) === 'lgtv' &&
          !this.userService.hasPermission('mrtCtvStoreLG')
        ) {
          break;
        }
        return true;
    }

    toastr.error(msg, { timeOut: 10000, extendedTimeOut: 0 });

    return this.router.parseUrl('/rankings');
  }
}
